import { Platform } from 'react-native';

/**
 * Hook to determine if the application is running in a browser
 */
export const useIsWeb = (): boolean => {
  return Platform.OS === 'web';
};
